theme.announcement = (function () {
  function announcementModule(e) {
    let announcementList = e.querySelectorAll(".announcement-bar");
    announcementList.forEach((element) => {
      element.addEventListener("click", (evt) => {
        let evtTargetElement = evt.target;
        if (evtTargetElement.classList.contains("close__announcement--bar")) {
          evtTargetElement.parentElement.remove();
        }
      });
    });
  }
  return announcementModule;
})();
